import { Component } from '@angular/core';
import { StatusButtons } from "../../../_shared/interfaces";
import { OffersOverviewComponent } from "./offers-overview/offers-overview.component";
import { NgForOf } from "@angular/common";

@Component({
  selector: 'app-offers',
  standalone: true,
  imports: [
    OffersOverviewComponent,
    NgForOf
  ],
  templateUrl: './offers.component.html',
  styleUrl: './offers.component.sass'
})
export class OffersComponent {
  status: string = 'sent';

  statusButtons: StatusButtons[] = [
    { state: 'all', display: 'Alle', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'sent', display: 'Abgeschickt', label: 'alert-info', icon: 'check-circle'},
    { state: 'rejected', display: 'Entgangen', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'confirmed', display: 'Akzeptiert', label: 'alert-success', icon: 'check-circle'}
  ];

  constructor() { }

  changeOverviewStatus(statusIndex: number){
    this.status = this.statusButtons[statusIndex].state;
  }
}
